<template>
  <div id="grafico-imobilizado-acumulado">
    <v-col class="d-flex ml-auto" cols="4" sm="4">
      <v-select v-if="loaded" v-model="yearSelected" label="Selecione" :items="years" dense outlined></v-select>
    </v-col>
    <highcharts v-if="loaded" :options="chartOptions" />
  </div>
</template>

<script>
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';
  import GraficosService from '@/services/GraficosService';
  import More from 'highcharts/highcharts-more';
  import Highcharts from 'highcharts';
  import dayjs from 'dayjs';

  More(Highcharts);

  export default {
    mixins: [dateFormatterMixins],
    data: () => ({
      dados: [],
      yearSelected: null
    }),
    computed: {
      loaded() {
        return this.dados && this.dados.length != 0;
      },
      years: function () {
        var array = [];
        var aux = this.dados;

        aux.forEach(function (element, index) {
          array[index] = dayjs(element.DATA_BASE).format('YYYY');
        });

        array.push('LTM');

        return [...new Set(array.reverse())];
      },
      meses() {
        var array = [];
        var aux = this.dados;

        if (this.yearSelected && this.yearSelected !== 'LTM') {
          aux = aux.filter((item) => dayjs(item.DATA_BASE).format('YYYY') === this.yearSelected);
        }

        aux.forEach(function (element) {
          array.push(dayjs(element.DATA_BASE).format('MM/YYYY'));
        });

        return array.slice(-12);
      },
      voc_mensal() {
        var array = [];
        var aux = this.dados;
        var filtroVocMensal = [];

        for (let index in this.meses) {
          filtroVocMensal.push(aux.filter((item) => dayjs(item.DATA_BASE).format('MM/YYYY') === this.meses[index]));
        }

        for (let index in filtroVocMensal) {
          array.push(parseFloat(filtroVocMensal[index][0].VOC_MENSAL).toFixed(2));
        }

        return array.map((value) => parseFloat(value));
      },
      voc_acumulado() {
        var array = [];
        var aux = this.dados;
        var filtroVocAcumulado = [];

        for (let index in this.meses) {
          filtroVocAcumulado.push(aux.filter((item) => dayjs(item.DATA_BASE).format('MM/YYYY') === this.meses[index]));
        }

        for (let index in filtroVocAcumulado) {
          array.push(parseFloat(filtroVocAcumulado[index][0].VOC_ACUMULADO).toFixed(2));
        }

        return array.map((value) => parseFloat(value));
      },
      chartOptions() {
        return {
          chart: {
            zoomType: 'xy',
            style: {
              fontFamily: 'muli'
            },
            height: 250
          },
          credits: {
            enabled: false
          },
          title: {
            text: '',
            align: 'left'
          },
          xAxis: [
            {
              categories: this.meses,
              crosshair: true,
              labels: {
                style: {
                  fontSize: '0.8em'
                }
              }
            }
          ],
          yAxis: [
            {
              gridLineWidth: 0,
              title: {
                text: 'MM R$',
                style: {
                  color: Highcharts.getOptions().colors[3]
                }
              },
              labels: {
                formatter() {
                  return Highcharts.numberFormat(this.value / 1000000, 0, ',');
                },
                style: {
                  color: Highcharts.getOptions().colors[3]
                }
              }
            },
            {
              title: {
                text: 'MM R$',
                style: {
                  color: Highcharts.getOptions().colors[0]
                }
              },
              labels: {
                formatter() {
                  return Highcharts.numberFormat(this.value / 1000000, 0, ',');
                },
                style: {
                  color: Highcharts.getOptions().colors[0]
                }
              },
              opposite: true
            }
          ],
          tooltip: {
            shared: true
          },
          legend: {
            // enabled:false,
            align: 'center',
            verticalAlign: 'bottom',
            y: 20,
            floating: true,
            backgroundColor: Highcharts.defaultOptions.legend.backgroundColor
          },
          series: [
            {
              name: 'Mensal',
              type: 'column',
              yAxis: 1,
              data: this.voc_mensal,
              tooltip: {
                valuePrefix: 'R$ '
              },
              color: Highcharts.getOptions().colors[0]
            },
            {
              name: 'Acumulado',
              type: 'spline',
              data: this.voc_acumulado,
              tooltip: {
                valuePrefix: 'R$ '
              },
              color: Highcharts.getOptions().colors[3]
            }
          ]
        };
      }
    },
    mounted() {
      this.getDadosDashboard();
    },
    methods: {
      getDadosDashboard() {
        return GraficosService.getDadosByNome('Firebase - Imobilizado LTM')
          .then(({ data }) => {
            this.dados = Object.values(data.data);
          })
          .catch((err) => {
            this.$toast.error('Erro ao buscar os dados do Dashboard', '', {
              position: 'topRight'
            });
            console.error(err);
          });
      }
    }
  };
</script>

<style scoped>
  #grafico-imobilizado-acumulado {
    min-height: 250px;
    z-index: 0;
  }
</style>
